export default __webpack_public_path__ + "static/noise@2x-379af3302c06763e4dc034a88adb0143.png";